/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import thumbnail from 'assets/images/logo-icon.png';

function Img({ src, defaultSrc, lightBox, name, showLoading, ...rest }) {
  const [url, setUrl] = React.useState(src || defaultSrc);
  const [isLoading, setIsLoading] = React.useState(true);
  const handleLoad = () => {
    setIsLoading(false);
  };
  const handleError = () => {
    setUrl(defaultSrc);
  };
  React.useEffect(() => {
    setUrl(src || defaultSrc);
  }, [src]); // eslint-disable-line

  if (name) {
    return (
      <div className="bg-primary-500 rounded-full w-8 h-8 p-4 flex items-center justify-center text-white font-semibold text-sm ">
        {name.charAt(0).toUpperCase()}
      </div>
    );
  }
  return (
    <>
      <img
        alt="thumb"
        onLoad={handleLoad}
        onError={handleError}
        role="presentation"
        style={{ cursor: lightBox ? 'pointer' : 'initial' }}
        {...rest}
        src={url}
      />
      {showLoading && isLoading && (
        <div className="flex h-full w-full bg-black bg-opacity-50 top-0 left-0 absolute">
          <div className="m-auto text-white">
            <i className="fa fa-spin fa-spinner" />
          </div>
        </div>
      )}
    </>
  );
}

Img.propTypes = {
  src: PropTypes.string,
  defaultSrc: PropTypes.string,
  lightBox: PropTypes.bool,
  name: PropTypes.string,
  showLoading: PropTypes.bool,
};

Img.defaultProps = {
  src: '',
  defaultSrc: thumbnail,
  lightBox: false,
  name: '',
  showLoading: false,
};

export default Img;
